import { apiRequest } from "../../lib/api-client";

export type GateHost = { id: number; name: string; department?: string | null };

export type GateContext = {
  company_name: string;
  company_code: string;
  hosts: GateHost[];
  required_fields: string[];
};

export type GateRegisterResult = {
  visit_id: number;
  badge_code: string;
  status: string;
  visitor_name: string;
};

export function getGateContext(token: string) {
  return apiRequest<GateContext>(`/gate/${encodeURIComponent(token)}`);
}

export type GateScanResult = {
  id_type: string | null;
  id_number: string | null;
  full_name: string | null;
  valid: boolean;
  validation_message: string;
};

export function scanGateId(token: string, image: File) {
  const form = new FormData();
  form.set("id_image", image);
  return apiRequest<GateScanResult>(`/gate/${encodeURIComponent(token)}/scan-id`, {
    method: "POST",
    body: form,
  });
}

export type GateRegisterPayload = {
  fullName: string;
  hostId: number;
  purpose: string;
  phone: string;
  email: string;
  companyName: string;
  notes: string;
  idType: string;
  idNumber: string;
  hasLaptop: boolean;
  laptopMac: string;
  laptopSerial: string;
  photo: File | null;
  idDocument: File | null;
};

export function registerAtGate(token: string, p: GateRegisterPayload) {
  const form = new FormData();
  form.set("full_name", p.fullName);
  form.set("host_id", String(p.hostId));
  form.set("purpose", p.purpose);
  if (p.phone) form.set("phone", p.phone);
  if (p.email) form.set("email", p.email);
  if (p.companyName) form.set("company_name", p.companyName);
  if (p.notes) form.set("notes", p.notes);
  if (p.idType) form.set("id_type", p.idType);
  if (p.idNumber) form.set("id_number", p.idNumber);
  form.set("has_laptop", String(p.hasLaptop));
  if (p.hasLaptop && p.laptopMac) form.set("laptop_mac_address", p.laptopMac);
  if (p.hasLaptop && p.laptopSerial) form.set("laptop_serial_number", p.laptopSerial);
  if (p.photo) form.set("photo", p.photo);
  if (p.idDocument) form.set("id_document", p.idDocument);

  return apiRequest<GateRegisterResult>(`/gate/${encodeURIComponent(token)}/register`, {
    method: "POST",
    body: form,
  });
}
